import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VList,
    {
      class: { "pb-3": _setup.isMobile },
      attrs: { "data-qa": "reviews_filter_list" },
    },
    [
      _vm._l(_setup.reviewsList, function (review) {
        return [
          !review.disabled
            ? _c(
                VListItem,
                {
                  key: review.value,
                  class: { "bg-primary": review.isActive },
                  attrs: {
                    disabled: review.disabled,
                    "data-qa": `reviews_filter_list_item_${review.value}`,
                  },
                  on: {
                    click: function ($event) {
                      return _setup.handleClickItem(review)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-space-between align-center w-100",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "text-body-1",
                          class: {
                            "text--text": !review.isActive && !review.disabled,
                            "primary--text ": review.isActive,
                          },
                          attrs: { "data-qa": "reviews_filter_title" },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(review.title) + "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-caption text--text px-2 py-1 rounded-sm",
                          class: review.backgroundColorLabel,
                          attrs: { "data-qa": "reviews_filter_amount" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(review.amount) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }